/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
import { colors } from "../../components/atoms/color-picker/color-picker";

export const ColorsProfileActivity = (profileActivityName: string) => {
    let hash = 0;
    for (let i = 0; i < profileActivityName.length; i++) {
        hash = profileActivityName.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % colors.length;
    return colors[index];
};
